import routes from "./routes";

/* -------------------------------------------------------------------------- */
/*                                    page                                    */
/* -------------------------------------------------------------------------- */
import Home from "src/pages/homes";
import HomePanel from "src/pages/panel";

import profile from "src/pages/profile";

import service from "src/pages/services";
import packages from "src/pages/services/packages";
import servicePackage from "src/pages/services/packages/servicePackage";

import providers from "src/pages/providers";
import orders from "src/pages/order";
import financial from "src/pages/financial";
import payment from "src/pages/payment";

import role from "src/pages/auth/role";
import permission from "src/pages/auth/permission";

import loyalityLevel from "src/pages/management/loyalityLevel";

import product from "src/pages/product";
import domain from "src/pages/domain";
import buyProduct from "src/pages/buyProducts";

import notificationManagement from "src/pages/management/notification";
import users from "src/pages/auth/user";
import socialNetwork from "src/pages/management/socialNetwork";
import tags from "src/pages/management/tags";
import commentsCategory from "src/pages/management/comments/commentCategory";
import comments from "src/pages/management/comments/comment";
import taskScheduler from "src/pages/management/taskScheduler";
import theme from "src/pages/management/theme";
import paymentGateway from "src/pages/management/paymentGateway";
import menu from "src/pages/management/menu";
import sms from "src/pages/management/sms";
import foreignApi from "src/pages/management/foreignApi";

import representation from "src/pages/whitelabel/representation";
import whiteLabelPlan from "src/pages/whitelabel/plan";
import productOrder from "src/pages/whitelabel/productOrder";
import productOrderAutoGift from "src/pages/whitelabel/productOrderAutoGift";

import automationOrder from "src/pages/automationOrder";

import account from "src/pages/serviceProviderTesting/account";
import campain from "src/pages/serviceProviderTesting/campain";
import campainServiceProvider from "src/pages/serviceProviderTesting/campainServiceProvider";

import support from "src/pages/support";
import api from "src/pages/api";

import whatsappCraeteClient from "src/pages/whatsapp/createClient";
import loyalityLevelEndUserPage from "src/pages/loyalityLevel/index";

import whatsappCategory from "src/pages/whatsappCategory";

import whatsappUsers from "src/pages/whatsappUsers";
import divarAuth from "src/pages/wecScraper/divarAuth";

import DiscountAdmin from "src/pages/discount/Admin/index";

import language from "src/pages/management/language";
import languageBookeroUser from "src/pages/bookeroUser/language";

import socialBookeroUser from "src/pages/bookeroUser/social";

import Checkout from "src/pages/checkout";
import Maintenance from "src/pages/maintenance/index";
import ServicesPublic from 'src/pages/public/services'
import NotFound from "src/pages/NotFoundPage";

const routers = [
  {
    path: routes.public.HomeWhitelable,
    exact: true,
    Component: Home,
    protect: false,
  },
  /* --------------------------------- profile -------------------------------- */
  {
    path: routes.public.services,
    exact: true,
    Component: ServicesPublic,
    protect: false,
  },
  /* --------------------------------- profile -------------------------------- */
  {
    path: routes.public.maintenance,
    exact: true,
    Component: Maintenance,
    protect: false,
    // title: "maintenance",
  },
  {
    path: routes.panel.HomePanel,
    exact: true,
    Component: HomePanel,
    protect: true,
  },

  /* --------------------------------- profile -------------------------------- */
  {
    path: routes.panel.profile.tagrani,
    exact: true,
    Component: profile.tagraniProfile,
    protect: true,
    title: "tagrani profile",
  },
  {
    path: routes.panel.profile.bookero,
    exact: true,
    Component: profile.bookeroProfile,
    protect: true,
    title: "bookero profile",
  },

  /* -------------------------------------------------------------------------- */
  /*                                  discount                                  */
  /* -------------------------------------------------------------------------- */

  /* --------------------------------- DiscountAdmin -------------------------------- */
  {
    path: routes.panel.discount.admin.create,
    exact: true,
    Component: DiscountAdmin.create,
    protect: true,
    title: "create discount ( admin )",
  },
  {
    path: routes.panel.discount.admin.list,
    exact: true,
    Component: DiscountAdmin.list,
    protect: true,
    title: "list discount ( admin )",
  },

  /* --------------------------------- service -------------------------------- */
  {
    path: routes.panel.service.list,
    exact: true,
    Component: service.list,
    protect: true,
    permission: { route: "/services", method: "GET" },
    title: "services list",
  },
  {
    path: routes.panel.service.create,
    exact: true,
    Component: service.create,
    protect: true,
    permission: { route: "/services", method: "POST" },
    title: "create service",
  },
  {
    path: routes.panel.service.update,
    exact: true,
    Component: service.create,
    protect: true,
    permission: { route: "/services/:id", method: "PATCH" },
  },
  /* --------------------------------- package -------------------------------- */
  {
    path: routes.panel.service.packages.list,
    exact: true,
    Component: packages.list,
    protect: true,
    permission: { route: "/services/package", method: "GET" },
    title: "packages list",
  },
  {
    path: routes.panel.service.packages.create,
    exact: true,
    Component: packages.create,
    protect: true,
    permission: { route: "/services/package", method: "POST" },
    title: "create package",
  },
  {
    path: routes.panel.service.packages.update,
    exact: true,
    Component: packages.create,
    protect: true,
    permission: { route: "/services/package/:id", method: "PATCH" },
  },
  /* --------------------------------- service Package -------------------------------- */
  {
    path: routes.panel.service.packages.servicePackage.list,
    exact: true,
    Component: servicePackage.list,
    protect: true,
    // permission: { route: "/childservices​/:serviceParentId", method: "PATCH" },
  },

  /* --------------------------------- product -------------------------------- */
  {
    path: routes.panel.products.list,
    exact: true,
    Component: product.list,
    protect: true,
    permission: { route: "/product", method: "GET" },
    title: "products list",
  },
  {
    path: routes.panel.products.create,
    exact: true,
    Component: product.create,
    protect: true,
    permission: { route: "/product", method: "POST" },
    title: "create product",
  },
  {
    path: routes.panel.products.edit,
    exact: true,
    Component: product.create,
    protect: true,
    permission: { route: "/product/:id", method: "PATCH" },
  },

  /* -------------------------------- providers ------------------------------- */
  {
    path: routes.panel.providers.list,
    exact: true,
    Component: providers.list,
    protect: true,
    permission: { route: "/provider", method: "GET" },
    title: "providers List",
  },
  {
    path: routes.panel.providers.create,
    exact: true,
    Component: providers.create,
    protect: true,
    permission: { route: "/provider", method: "POST" },
    title: "create provider",
  },
  {
    path: routes.panel.providers.edit,
    exact: true,
    Component: providers.create,
    protect: true,
    permission: { route: "/provider/:id", method: "PATCH" },
  },
  {
    path: routes.panel.providers.financial,
    exact: true,
    Component: providers.financial,
    protect: true,
  },

  /* -------------------------------- orders ------------------------------- */
  {
    path: routes.panel.orders.list,
    exact: true,
    Component: orders.list,
    protect: true,
    permission: { route: "/order", method: "GET" },
    title: "orders list",
  },
  {
    path: routes.panel.orders.create,
    exact: true,
    Component: orders.create,
    protect: true,
    permission: { route: "/order", method: "POST" },
    title: "create order",
  },
  {
    path: routes.panel.orders.edit,
    exact: true,
    Component: orders.create,
    protect: true,
    permission: { route: "/order/admin", method: "PATCH" },
  },
  /* -------------------------------- language ------------------------------- */
  {
    path: routes.panel.management.language.list,
    exact: true,
    Component: language.list,
    protect: true,
    // permission: { route: "/tags", method: "GET" },
    title: "language list",
  },
  {
    path: routes.panel.management.language.create,
    exact: true,
    Component: language.create,
    protect: true,
    // permission: { route: "/tags", method: "POST" },
    title: "language create",
  },
  {
    path: routes.panel.management.language.edit,
    exact: true,
    Component: language.create,
    protect: true,
    // permission: { route: "/tags", method: "POST" },
    // title: "language create",
  },
  /* -------------------------------- language bookero user ------------------------------- */
  {
    path: routes.panel.bookeroUser.language.list,
    exact: true,
    Component: languageBookeroUser.list,
    protect: true,
    // permission: { route: "/tags", method: "GET" },
    title: "language list bookero",
  },
  /* -------------------------------- social bookero user ------------------------------- */
  {
    path: routes.panel.bookeroUser.socialNetworks.list,
    exact: true,
    Component: socialBookeroUser.list,
    protect: true,
    // permission: { route: "/tags", method: "GET" },
    title: "social list bookero",
  },
  /* -------------------------------- tags ------------------------------- */
  {
    path: routes.panel.management.tags.list,
    exact: true,
    Component: tags.list,
    protect: true,
    permission: { route: "/tags", method: "GET" },
    title: "tags list",
  },
  {
    path: routes.panel.management.tags.create,
    exact: true,
    Component: tags.create,
    protect: true,
    permission: { route: "/tags", method: "POST" },
    title: "tag create",
  },
  {
    path: routes.panel.management.tags.edit,
    exact: true,
    Component: tags.create,
    protect: true,
    permission: { route: "/tags/:id", method: "PATCH" },
  },
  /* -------------------------------- comment category ------------------------------- */
  {
    path: routes.panel.management.comments.commentCategory.list,
    exact: true,
    Component: commentsCategory.list,
    protect: true,
    permission: { route: "/commentcategory", method: "GET" },
    title: "comment category list",
  },
  {
    path: routes.panel.management.comments.commentCategory.create,
    exact: true,
    Component: commentsCategory.create,
    protect: true,
    permission: { route: "/commentcategory", method: "POST" },
    title: "comment category create",
  },
  {
    path: routes.panel.management.comments.commentCategory.edit,
    exact: true,
    Component: commentsCategory.create,
    protect: true,
    permission: { route: "/commentcategory/:id", method: "PATCH" },
  },
  /* -------------------------------- comments ------------------------------- */
  {
    path: routes.panel.management.comments.comment.list,
    exact: true,
    Component: comments.list,
    protect: true,
    // permission: { route: "/comment/list", method: "GET" },
    // title: "comment list",
  },
  {
    path: routes.panel.management.comments.comment.create,
    exact: true,
    Component: comments.create,
    protect: true,
    // permission: { route: "/comment", method: "POST" },
    // title: "comment create",
  },
  {
    path: routes.panel.management.comments.comment.edit,
    exact: true,
    Component: comments.create,
    protect: true,
    permission: { route: "/comment/:id", method: "PATCH" },
  },
  /* -------------------------------- financial ------------------------------- */
  {
    path: routes.panel.financial.wallet,
    exact: true,
    Component: financial.wallet,
    protect: true,
    title: "wallet",
  },
  {
    path: routes.panel.financial.transactions,
    exact: true,
    Component: financial.transactions,
    protect: true,
    // permission: { route: "/wallet/transactions", method: "GET" },
    title: "transactions",
  },
  /* --------------------------------- support -------------------------------- */
  {
    path: routes.panel.support.list,
    exact: true,
    Component: support.list,
    protect: true,
    title: "support",
  },
  /* --------------------------------- divarAuth -------------------------------- */
  {
    path: routes.panel.webScraper.divarAuth.create,
    exact: true,
    Component: divarAuth.create,
    protect: true,
    title: "divarAuth create",
  },
  {
    path: routes.panel.webScraper.divarAuth.list,
    exact: true,
    Component: divarAuth.list,
    protect: true,
    title: "divarAuth list",
  },
  {
    path: routes.panel.webScraper.divarAuth.edit,
    exact: true,
    Component: divarAuth.create,
    protect: true,
    title: "divarAuth list",
  },
  /* --------------------------------- WhatsApp -------------------------------- */
  {
    path: routes.panel.whatsapp.listClient,
    exact: true,
    Component: whatsappCraeteClient.list,
    protect: true,
    title: "whatsapp client list",
  },
  {
    path: routes.panel.whatsapp.craeteClient,
    exact: true,
    Component: whatsappCraeteClient.create,
    protect: true,
    title: "whatsapp create client",
  },
  {
    path: routes.panel.whatsapp.editClient,
    exact: true,
    Component: whatsappCraeteClient.create,
    protect: true,
    title: "whatsapp edit client",
  },
  // {
  //   path: routes.panel.whatsapp.scanQrCode,
  //   exact: true,
  //   Component: whatsappScanQr.create,
  //   protect: true,
  //   title: "whatsapp scan qr code",
  // },
  /* --------------------------------- WhatsApp Category -------------------------------- */
  {
    path: routes.panel.whatsappCategory.list,
    exact: true,
    Component: whatsappCategory.list,
    protect: true,
    title: "whatsappCategory list",
  },
  {
    path: routes.panel.whatsappCategory.craete,
    exact: true,
    Component: whatsappCategory.create,
    protect: true,
    title: "whatsappCategory create",
  },
  {
    path: routes.panel.whatsappCategory.edit,
    exact: true,
    Component: whatsappCategory.create,
    protect: true,
    title: "whatsappCategory edit",
  },

  /* --------------------------------- WhatsApp Users -------------------------------- */
  {
    path: routes.panel.whatsappUsers.list,
    exact: true,
    Component: whatsappUsers.list,
    protect: true,
    title: "whatsappUsers list",
  },
  {
    path: routes.panel.whatsappUsers.craete,
    exact: true,
    Component: whatsappUsers.create,
    protect: true,
    title: "whatsappUsers create",
  },
  {
    path: routes.panel.whatsappUsers.craeteBulk,
    exact: true,
    Component: whatsappUsers.craeteBulk,
    protect: true,
    title: "whatsappUsers craeteBulk",
  },
  {
    path: routes.panel.whatsappUsers.edit,
    exact: true,
    Component: whatsappUsers.create,
    protect: true,
    title: "whatsappUsers edit",
  },

  /* --------------------------------- payment -------------------------------- */
  {
    path: routes.panel.payment,
    exact: true,
    Component: payment.list,
    protect: true,
    title: "list of payments",
  },

  /* -------------------------------- Buy Product ------------------------------- */
  {
    path: routes.panel.buyProduct,
    exact: true,
    Component: buyProduct.create,
    protect: true,
    permission: { route: "/checkout/buyproduct", method: "GET" },
    title: "buy product",
  },

  /* -------------------------------------------------------------------------- */
  /*                                 management                                 */
  /* -------------------------------------------------------------------------- */

  /* ----------------------------------- sms ---------------------------------- */
  {
    path: routes.panel.management.sms.list,
    exact: true,
    Component: sms.list,
    protect: true,
    title: "sms management",
  },
  {
    path: routes.panel.management.sms.edit,
    exact: true,
    Component: sms.edit,
    protect: true,
    title: "sms management",
  },
  {
    path: routes.panel.management.sms.campain.create,
    exact: true,
    Component: sms.smsCampainCreate,
    protect: true,
    title: "sms campain create",
  },
  {
    path: routes.panel.management.sms.campain.list,
    exact: true,
    Component: sms.smsCampainList,
    protect: true,
    title: "sms campain list",
  },
  {
    path: routes.panel.management.sms.campain.edit,
    exact: true,
    Component: sms.smsCampainCreate,
    protect: true,
  },
  /* ------------------------------ notifications ----------------------------- */
  {
    path: routes.panel.management.notifications,
    exact: true,
    Component: notificationManagement,
    protect: true,
    title: "notifications",
  },
  /* ------------------------------ LoyalityLevelEndUserPage ----------------------------- */
  {
    path: routes.panel.loyalityLevelEndUserPage,
    exact: true,
    Component: loyalityLevelEndUserPage,
    protect: true,
    title: "loyalityLevelEndUserPage",
  },

  /* ------------------------------ socialnetwork ----------------------------- */
  {
    path: routes.panel.management.socialNetworks.list,
    exact: true,
    Component: socialNetwork.list,
    protect: true,
    permission: { route: "/category", method: "GET" },
    title: "social networks list",
  },

  {
    path: routes.panel.management.socialNetworks.create,
    exact: true,
    Component: socialNetwork.create,
    protect: true,
    permission: { route: "/category", method: "POST" },
    title: "create social network",
  },
  {
    path: routes.panel.management.socialNetworks.edit,
    exact: true,
    Component: socialNetwork.create,
    protect: true,
    permission: { route: "/category/:id", method: "PATCH" },
  },
  /* ------------------------------ loyalityLevel ----------------------------- */
  {
    path: routes.panel.management.loyalityLevel.list,
    exact: true,
    Component: loyalityLevel.list,
    protect: true,
    permission: { route: "/product", method: "GET" },
    title: "loyality Level list",
  },
  {
    path: routes.panel.management.loyalityLevel.create,
    exact: true,
    Component: loyalityLevel.create,
    protect: true,
    title: "loyality Level create",
    permission: { route: "/product", method: "GET" },
  },
  {
    path: routes.panel.management.loyalityLevel.edit,
    exact: true,
    Component: loyalityLevel.create,
    protect: true,
    permission: { route: "/product", method: "GET" },
  },
  /* ------------------------------ taskScheduler ----------------------------- */
  {
    path: routes.panel.management.taskScheduler,
    exact: true,
    Component: taskScheduler,
    protect: true,
    permission: { route: "/taskscheduling/alltask", method: "GET" },
    title: "task scheduler",
  },
  /* ---------------------------------- theme --------------------------------- */
  {
    path: routes.panel.management.theme.list,
    exact: true,
    Component: theme.list,
    protect: true,
    permission: { route: "/theme", method: "GET" },
    title: "themes list",
  },
  {
    path: routes.panel.management.theme.create,
    exact: true,
    Component: theme.create,
    protect: true,
    permission: { route: "/theme", method: "POST" },
    title: "create theme",
  },
  {
    path: routes.panel.management.theme.edit,
    exact: true,
    Component: theme.create,
    protect: true,
    permission: { route: "/theme/:id", method: "PATCH" },
  },
  {
    path: routes.panel.management.menu,
    exact: true,
    Component: menu,
    protect: true,
    // permission: { route: "/theme/:id", method: "PATCH" },
    title: "menu management",
  },
  /* ----------------------------- payment gateway ---------------------------- */
  {
    path: routes.panel.management.paymentGateway.list,
    exact: true,
    Component: paymentGateway.list,
    protect: true,
    permission: { route: "/paymentgateway", method: "GET" },
    title: "payment gateways list",
  },
  {
    path: routes.panel.management.paymentGateway.create,
    exact: true,
    Component: paymentGateway.create,
    protect: true,
    permission: { route: "/paymentgateway", method: "POST" },
    title: "create payment gateway",
  },
  {
    path: routes.panel.management.paymentGateway.edit,
    exact: true,
    Component: paymentGateway.create,
    protect: true,
    permission: { route: "/paymentgateway/:id", method: "PATCH" },
  },

  /* ------------------------------- foreignApi ------------------------------- */
  {
    path: routes.panel.management.foreignApi.list,
    exact: true,
    Component: foreignApi.list,
    protect: true,
    // permission: { route: "/foreignApi", method: "GET" },
    // title: "payment gateways list",
  },
  {
    path: routes.panel.management.foreignApi.create,
    exact: true,
    Component: foreignApi.create,
    protect: true,
    // permission: { route: "/foreignApi", method: "POST" },
    // title: "create payment gateway",
  },
  {
    path: routes.panel.management.foreignApi.edit,
    exact: true,
    Component: foreignApi.create,
    protect: true,
    // permission: { route: "/foreignApi/:id", method: "PATCH" },
  },

  /* -------------------------------------------------------------------------- */
  /*                                    auth                                    */
  /* -------------------------------------------------------------------------- */
  /* ---------------------------------- role ---------------------------------- */
  {
    path: routes.panel.auth.roles.list,
    exact: true,
    Component: role.list,
    protect: true,
    permission: { route: "/auth/role", method: "GET" },
    title: "roles list",
  },
  {
    path: routes.panel.auth.roles.create,
    exact: true,
    Component: role.create,
    protect: true,
    permission: { route: "/auth/role", method: "POST" },
    title: "create role",
  },
  {
    path: routes.panel.auth.roles.edit,
    exact: true,
    Component: role.create,
    protect: true,
    permission: { route: "/auth/role/:id", method: "PATCH" },
  },
  {
    path: routes.panel.auth.roles.permisson,
    exact: true,
    Component: role.permissions,
    protect: true,
    permission: { route: "/auth/rolepermission", method: "PATCH" },
  },
  {
    path: routes.panel.auth.roles.menu,
    exact: true,
    Component: role.menu,
    protect: true,
    // permission: { route: "/auth/rolepermission", method: "PATCH" },
  },
  /* ------------------------------- permission ------------------------------- */
  {
    path: routes.panel.auth.permissions.list,
    exact: true,
    Component: permission.list,
    protect: true,
    permission: { route: "/auth/permission", method: "GET" },
    title: "permissions list",
  },
  {
    path: routes.panel.auth.permissions.edit,
    exact: true,
    Component: permission.create,
    protect: true,
    permission: { route: "/auth/permission/:id", method: "PATCH" },
  },
  /* ---------------------------------- users --------------------------------- */
  {
    path: routes.panel.auth.users.list,
    exact: true,
    Component: users.users,
    protect: true,
    // permission: { route: "/auth/user", method: "GET" },
    title: "users list",
  },
  {
    path: routes.panel.auth.users.role,
    exact: true,
    Component: users.roles,
    protect: true,
    permission: { route: "/auth/userrole", method: "PATCH" },
  },
  /* ----------------------------------- api ---------------------------------- */
  {
    path: routes.panel.api,
    exact: true,
    Component: api,
    protect: true,
    title: "api",
  },

  /* -------------------------------------------------------------------------- */
  /*                                 whitelabel                                 */
  /* -------------------------------------------------------------------------- */
  {
    path: routes.panel.whitelabel.representation,
    exact: true,
    Component: representation,
    protect: true,
    title: "representation whitelabel",
    permission: { route: "/auth/bookero/completeprofile", method: "PATCH" },
  },
  /* ---------------------------- white label plan ---------------------------- */
  {
    path: routes.panel.whitelabel.plan.myPlan,
    exact: true,
    Component: whiteLabelPlan.myPlan,
    protect: true,
    title: "my plans",
  },

  /* ------------------------------ product Order ----------------------------- */
  {
    path: routes.panel.whitelabel.productOrder,
    exact: true,
    Component: productOrder,
    protect: true,
    title: "products orders",
  },
  {
    path: routes.panel.whitelabel.productOrderAutoGift,
    exact: true,
    Component: productOrderAutoGift,
    protect: true,
    title: "orders gift",
  },
  /* -------------------------------------------------------------------------- */
  /*                           serviceProviderTesting                           */
  /* -------------------------------------------------------------------------- */

  /* --------------------------------- account -------------------------------- */
  {
    path: routes.panel.serviceProviderTesting.account.list,
    exact: true,
    Component: account.list,
    protect: true,
    title: "accounts list",
  },

  /* --------------------------------- campain --------------------------------- */

  {
    path: routes.panel.serviceProviderTesting.campain.list,
    exact: true,
    Component: campain.list,
    protect: true,
    title: "campains list",
  },

  {
    path: routes.panel.serviceProviderTesting.campain.create,
    exact: true,
    Component: campain.create,
    protect: true,
    title: "create campain",
  },
  {
    path: routes.panel.serviceProviderTesting.campain.edit,
    exact: true,
    Component: campain.create,
    protect: true,
  },
  {
    path: routes.panel.serviceProviderTesting.campain.manual,
    exact: true,
    Component: campain.manual,
    protect: true,
  },
  {
    path: routes.panel.serviceProviderTesting.campain.result,
    exact: true,
    Component: campain.result,
    protect: true,
  },
  /* ------------------------ campain service provider ------------------------ */
  {
    path: routes.panel.serviceProviderTesting.campainServiceProvider.list,
    exact: true,
    Component: campainServiceProvider.list,
    protect: true,
    title: "service provider account list",
  },
  {
    path: routes.panel.serviceProviderTesting.campainServiceProvider
      .accountFollowers,
    exact: true,
    Component: campainServiceProvider.accountFollowers,
    protect: true,
  },
  /* -------------------------------------------------------------------------- */
  /*                                   domain                                   */
  /* -------------------------------------------------------------------------- */
  {
    path: routes.panel.domain.list,
    exact: true,
    Component: domain.list,
    protect: true,
    title: "domains list",
  },
  {
    path: routes.panel.domain.create,
    exact: true,
    Component: domain.create,
    protect: true,
    title: "create domain",
  },
  {
    path: routes.panel.domain.update,
    exact: true,
    Component: domain.create,
    protect: true,
  },
  {
    path: routes.panel.domain.update,
    exact: true,
    Component: domain.create,
    protect: true,
  },

  /* ---------------------------- automation order ---------------------------- */
  {
    path: routes.panel.automationOrder.list,
    exact: true,
    Component: automationOrder.myAutomation,
    protect: true,
    title: "auto orders",
  },

  /* -------------------------------------------------------------------------- */
  /*                                   Public                                   */
  /* -------------------------------------------------------------------------- */

  {
    path: routes.public.checkout,
    exact: true,
    Component: Checkout,
    protect: false,
  },
  {
    path: routes.public.payment.success,
    exact: true,
    Component: payment.success,
    protect: false,
  },
  {
    path: routes.public.payment.error,
    exact: true,
    Component: payment.error,
    protect: false,
  },
  // {
  //   path: "*",
  //   exact: true,
  //   Component: NotFound,
  //   protect: false,
  // },
];

export default routers;
